import React, { ReactNode } from "react";

interface SDKWrapperProps {
  children: ReactNode;
  className?: string;
}

/**
 * SDKWrapper component that wraps all SDK components with a root class
 * This ensures all Tailwind styles are scoped and don't affect the host application
 */
export function SDKWrapper({ children, className = "" }: SDKWrapperProps) {
  return <div className={`swype-sdk-root ${className}`}>{children}</div>;
}
